// extracted by mini-css-extract-plugin
module.exports = {"acciones":"ListaRecibos_acciones__2mwtF"};